<script>
import { _ } from 'svelte-i18n';
import { info_client } from '../stores';

export let slug;
export let title;
export let index;
export let count;
export let pub_start_date;

const getTagName = () => {
  return ($info_client.language === 'en' ? slug : title).toUpperCase();
};
</script>

<div 
  class="name text-grey text-bold"
  class:dot={index !== count - 1 || pub_start_date}
>
  {getTagName()}
</div>

<style>
  .name {
    font-size: 10px;
    line-height: 14px;
  }
</style>
